<template>
  <div>
    <div class="adsdetail-cnt" v-if="adsDetail">
      <header class="inner-header">
        <div class="top-head">
          <backIcon />
          <span
            class="edit-btn"
            @click="
              $router.push({
                path: '/create-ad-form',
                query: { detail: adsDetail },
              })
            "
            >Edit detail</span
          >
        </div>

        <h2>
          {{ adsDetail.name }}
        </h2>
      </header>

      <section class="mid-cnt">
        <div class="ads-status">
          <!-- <div class="status-col">
            <span class="text-val">12</span>
            <p>Orders</p>
          </div> -->
          <div class="status-col">
            <div class="status-box">
              <span class="text-val">{{ adsDetail.clickCount }}</span>
              <p>Clicks</p>
            </div>
          </div>

          <div class="status-col">
            <div class="status-box">
              <span class="text-val">{{ adsDetail.viewCount }}</span>
              <p>Viewers</p>
            </div>
          </div>
        </div>

        <!-- <div class="order-dtl">
          <h3>Order ID: <span>#ads78654</span></h3>
          <h4>{{ adsDetail.name }}</h4>
          <p>
            {{
              adsDetail.campaignAction.callNumber ||
                adsDetail.campaignAction.whatsAppNumber
            }}
          </p>
          <p>15 Jul 20, 15:32 PM</p>
          <p>I.T. Tower, Plot No 29, Sector 142, Noida, Uttar Pradesh 201301</p>
          <p>Amount Paid:<span>₹120</span></p>
          <p>Ad Fees Deduction:<span>₹10</span></p>
        </div> -->

        <div class="order-dtl info-data">
          <div class="info-col">
            <h4>{{ adsDetail.name }}</h4>

            <div
              class="text-data"
              v-if="
                adsDetail.campaignAction.callNumber ||
                  adsDetail.campaignAction.whatsAppNumber
              "
            >
              <span>Customer Phone:</span>
              <span>{{
                adsDetail.campaignAction.callNumber ||
                  adsDetail.campaignAction.whatsAppNumber
              }}</span>
            </div>

            <div class="text-data">
              <span>Source:</span>
              <span>{{ adsDetail.campaignAction.action }}</span>
            </div>

            <div class="text-data">
              <span>Date:</span>
              <span>{{ extractDate(adsDetail.startDate) }}</span>
            </div>
          </div>
          <div class="prdt-col" v-if="adsDetail.campaignMedia.length">
            <img
              :src="
                adsDetail.campaignMedia && adsDetail.campaignMedia[0].mediaURL
              "
            />
          </div>
          <div class="prdt-desc">
            {{ adsDetail.description }}
          </div>

          <!-- <div class="text-data">
            <span>Ad Fees Deduction:</span>
            <span class="text-amt">₹10</span>
          </div> -->
        </div>
      </section>
    </div>
    <loadingIcon v-if="loading" />
    <Toaster :dataValue="toasterData" />
  </div>
</template>
<script>
import backIcon from "../components/icons/backIcon";
import Toaster from "../components/Toaster";
import loadingIcon from "../components/icons/loadingIcon";

export default {
  name: "AdDetails",
  components: {
    backIcon,
    Toaster,
    loadingIcon,
  },
  data() {
    return {
      adsDetail: null,
      toasterData: {},
      loading: true,
    };
  },
  methods: {
    extractDate(timestamp) {
      const month = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      return (
        new Date(timestamp).getDate() +
        " " +
        month[new Date(timestamp).getMonth()] +
        " " +
        new Date(timestamp).getFullYear()
      );
    },
  },
  mounted() {
    this.$store
      .dispatch({ type: "AdsDetail", payload: this.$route.query.AdNo })
      .then((data) => {
        console.log("==data detail=", data);
        if (data.httpStatus === 200) {
          this.adsDetail = data.data;
          this.loading = false;
          console.log("===", this.adsDetail);
        } else {
          this.loading = false;
          this.toasterData = {
            status: true,
            msg: data.message,
            timeoutMs: "5000",
            color: "#000",
          };
        }
      });
  },
};
</script>
